/* @flow */

import type { CombinedReducers } from '../../../reducers';
import type { Dispatch } from '../../../types/types';
import type { ApplicationInfo, NetgemApiEmitterType, RequestResponseMethodDefinitionType } from '../emitter';

import { getFcmToken } from '../../../../firebase';
import { firebaseConfig } from '../../../../helpers/applicationCustomization/ui';
import AccurateTimestamp from '../../../../helpers/dateTime/AccurateTimestamp';
import { getBrowserAndOS } from '../../../../helpers/jsHelpers/environment';
import { REDUX_MSG_REQUEST_GET_DEVICE_SETTINGS } from '../../constants/';

const UNKNOWN = 'unknown';

const sendGetDeviceSettingsRequest: (signal?: AbortSignal) => RequestResponseMethodDefinitionType =
  (signal) =>
  async (dispatch: Dispatch, getState: () => CombinedReducers, NetgemApiEmitter: NetgemApiEmitterType): Promise<void> => {
    const { browserName, browserVersion, osName, osVersion } = getBrowserAndOS();
    const {
      appConfiguration: { versionApp },
    } = getState();

    const {
      devicePixelRatio,
      screen: { height, width },
    } = window;

    // Firebase info
    const fcmToken = await getFcmToken();
    const { projectId: fcmProjectId } = firebaseConfig;

    const appInfo: ApplicationInfo = {
      appVersion: versionApp,
      browserName: browserName ?? UNKNOWN,
      browserVersion: browserVersion ?? UNKNOWN,
      displayResolution: `${width}x${height}`,
      fcmProjectId,
      fcmToken: fcmToken ?? '',
      osName: osName ?? UNKNOWN,
      osVersion: osVersion ?? UNKNOWN,
      screenResolution: `${width * devicePixelRatio}x${height * devicePixelRatio}`,
      timestamp: AccurateTimestamp.nowAsIsoString(),
    };

    return NetgemApiEmitter.emit(REDUX_MSG_REQUEST_GET_DEVICE_SETTINGS, { appInfo, signal });
  };

export default sendGetDeviceSettingsRequest;
